"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var compLayoutUtils_1 = require("./structure2mesh/compLayoutUtils");
var calculateGridPoints_1 = require("./structure2mesh/calculateGridPoints");
var calculateCompsGridData_1 = require("./structure2mesh/calculateCompsGridData");
var meshCssUtils_1 = require("./structure2mesh/meshCssUtils");
var getGridWrapperId = function (containerId) { return containerId + "-gridWrapper"; };
var getGridContainerId = function (containerId) { return containerId + "-gridContainer"; };
var getGridVerticalArea = function (container, compsMinTop, compsMaxBottom) {
    var areaTop = _.min([0, compsMinTop]);
    var areaBottom = _.max([container.height || 0, container.minHeight || 0, compsMaxBottom]);
    return {
        top: areaTop,
        bottom: areaBottom
    };
};
var childrenContainerMinHeight = function (comp, mostBottom, gridOverflow, _a) {
    var minLockMargin = _a.minLockMargin;
    var overflowTop = _.get(gridOverflow, 'top', 0);
    if (compLayoutUtils_1.fitToContentHeight(comp)) {
        return _.isUndefined(comp.minHeight) ? 'auto' : meshCssUtils_1.unitize(comp.minHeight + overflowTop);
    }
    var isSoft = comp.height - mostBottom > minLockMargin;
    if (isSoft) {
        return meshCssUtils_1.unitize(_.max([comp.height, comp.minHeight]) + overflowTop);
    }
    return _.isUndefined(comp.minHeight) ? 'auto' : meshCssUtils_1.unitize(comp.minHeight + overflowTop);
};
var getGridOverflow = function (container, gridVerticalArea) {
    var overflowFromTop = 0 - gridVerticalArea.top;
    var overflowFromBottom = compLayoutUtils_1.fitToContentHeight(container) ? 0 : gridVerticalArea.bottom - compLayoutUtils_1.getContainerHeight(container);
    if (!overflowFromTop && !overflowFromBottom) {
        return null;
    }
    return {
        top: overflowFromTop,
        bottom: overflowFromBottom
    };
};
var getRootStructure = function (meshHierarchy, containerId) {
    var getCompStructure = function (compId, childrenIds) {
        if (childrenIds === void 0) { childrenIds = []; }
        return ({
            id: compId,
            children: _.map(childrenIds, function (childId) { return getCompStructure(childId, meshHierarchy[childId]); })
        });
    };
    return getCompStructure(containerId, meshHierarchy[containerId]);
};
var getLeafMeshData = function (container) {
    var _a, _b;
    return ({
        id: container.id,
        hierarchy: (_a = {}, _a[container.id] = [], _a),
        styles: (_b = {}, _b[container.id] = meshCssUtils_1.getLeafStyle(container), _b)
    });
};
var addChildToMesh = function (containerMeshData, _a) {
    var style = _a.style, id = _a.id;
    containerMeshData.hierarchy[getGridContainerId(containerMeshData.id)].push(id);
    containerMeshData.styles[id] = style;
    return containerMeshData;
};
var addComponentsToMesh = function (container, containerMeshData, components, compsGridData, gridVerticalArea, overflow, meshOptions) {
    _(components)
        .map(function (child) {
        var style = child.absolute ? meshCssUtils_1.getCompAbsoluteStyle(child, overflow) : meshCssUtils_1.getCompStyles(child, compsGridData[child.id], gridVerticalArea, container, meshOptions);
        return {
            id: child.id,
            style: style
        };
    })
        .reduce(addChildToMesh, containerMeshData);
};
var addWedgesToMesh = function (containerMeshData, compsGridData, _a) {
    var cssGridVariant = _a.cssGridVariant;
    var ie = cssGridVariant === 'ms';
    _(compsGridData)
        .pickBy(function (compGridData) { return compGridData.isWedge; })
        .map(function (wedgeGridData) { return ({
        id: containerMeshData.id + "-" + wedgeGridData.id,
        style: meshCssUtils_1.getWedgeStyle(wedgeGridData, ie)
    }); })
        .reduce(addChildToMesh, containerMeshData);
};
var createContainerMeshData = function (container, numberOfRows, containerMinHeight, gridOverflow, _a) {
    var cssGridVariant = _a.cssGridVariant;
    var _b, _c;
    var containerId = container.id;
    var gridWrapperId = getGridWrapperId(containerId);
    var gridContentId = getGridContainerId(containerId);
    var hierarchy = (_b = {},
        _b[containerId] = [
            gridWrapperId
        ],
        _b[gridWrapperId] = [
            gridContentId
        ],
        _b[gridContentId] = [],
        _b);
    var containerStyle = meshCssUtils_1.getRootContainerStyle(container);
    var gridWrapperStyle = meshCssUtils_1.getGridWrapperStyle(gridOverflow);
    var gridContainerStyles = meshCssUtils_1.getGridContainerStyles(cssGridVariant, numberOfRows, gridOverflow, containerMinHeight);
    var styles = (_c = {},
        _c[containerId] = containerStyle,
        _c[gridWrapperId] = gridWrapperStyle,
        _c[gridContentId] = gridContainerStyles,
        _c);
    return {
        id: containerId,
        hierarchy: hierarchy,
        styles: styles
    };
};
var getGridDataForMesh = function (container, gridComponents, marginsOptions) {
    var compsMinTop = _(gridComponents).map(compLayoutUtils_1.top).min();
    var compsMaxBottom = _(gridComponents).map(compLayoutUtils_1.bottom).max();
    var verticalArea = getGridVerticalArea(container, compsMinTop, compsMaxBottom);
    var gridOverflow = getGridOverflow(container, verticalArea);
    var sortedGridPointsData = calculateGridPoints_1.default(gridComponents);
    var compsGridData = calculateCompsGridData_1.default(sortedGridPointsData, verticalArea, marginsOptions);
    var numberOfRows = _(compsGridData).map('rowEnd').max() - 1;
    return {
        verticalArea: verticalArea,
        numberOfRows: numberOfRows,
        compsGridData: compsGridData,
        overflow: gridOverflow,
        containerMinHeight: childrenContainerMinHeight(container, compsMaxBottom, gridOverflow, marginsOptions)
    };
};
function createMeshData(container, meshOptions) {
    if (_.isEmpty(container.components)) {
        return getLeafMeshData(container);
    }
    var gridComponents = _.reject(container.components, 'absolute');
    var _a = getGridDataForMesh(container, gridComponents, meshOptions), numberOfRows = _a.numberOfRows, verticalArea = _a.verticalArea, containerMinHeight = _a.containerMinHeight, overflow = _a.overflow, compsGridData = _a.compsGridData;
    var containerMeshData = createContainerMeshData(container, numberOfRows, containerMinHeight, overflow, meshOptions);
    addComponentsToMesh(container, containerMeshData, container.components, compsGridData, verticalArea, overflow, meshOptions);
    addWedgesToMesh(containerMeshData, compsGridData, meshOptions);
    return containerMeshData;
}
exports.createMeshData = createMeshData;
exports.structure2mesh = function (container, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.cssGridVariant, cssGridVariant = _c === void 0 ? 'standard' : _c, _d = _b.softMargin, softMargin = _d === void 0 ? 10 : _d, _e = _b.minLockMargin, minLockMargin = _e === void 0 ? 70 : _e;
    if (_.isUndefined(container.id)) {
        container = _.defaults({ id: 'root' }, container);
    }
    // TODO: YotamB 09/07/2018 - maybe return flat ftructure?
    var _f = createMeshData(container, { cssGridVariant: cssGridVariant, softMargin: softMargin, minLockMargin: minLockMargin }), hierarchy = _f.hierarchy, styles = _f.styles;
    return {
        structure: getRootStructure(hierarchy, container.id),
        styles: styles
    };
};
//# sourceMappingURL=structure2mesh.js.map